// Сообщение для ИИ-агентов, работающих в браузере (Claude in Chrome, Operator и т. п.).
//
// Работать через интерфейс агенту можно — как человеку. Нельзя ходить во внутренний
// API напрямую: fetch/XHR из консоли, скрипты с токеном из localStorage. Такие вызовы
// бэкенд помечает (InternalApiAutomationGuard, rentalman-api). Отклонять начнёт, когда
// MCP-каталог покроет сценарии скриптов (решение USER 29.09), — до тех пор текст не
// грозит блокировкой, а ведёт на легальный путь.
// Агенты читают консоль страницы, поэтому текст адресован им, а не пользователю.
//
// Тот же текст — в public/llms.txt и в комментарии public/index.html.
// FT-189: CLI для агентов с терминалом — пакет и мажор в одном месте; окно ключа берёт его отсюда.
export const CLI_PACKAGE = "@rentprog/cli@0";

export const AGENT_NOTICE =
  "RentProg notice for AI agents: you may use the RentProg web interface like a human user. " +
  "Direct calls to the RentProg internal API (fetch/XHR from the console, scripts using the " +
  "session token) are not permitted by the RentProg Terms of Service. " +
  "For automation, use the official RentProg MCP connector: /mcp with a personal key from " +
  "Profile > AI agent keys (plugin: https://github.com/RentProg/rentprog-claude-plugin), " +
  `or, for agents with a terminal, the RentProg CLI: npx -y ${CLI_PACKAGE} with the same key ` +
  "(if the tab or access is missing, contact RentProg support).";

export function printAgentNotice(logger = console) {
  logger.info(AGENT_NOTICE);
}
